export default __webpack_public_path__ + "static/media/Icon feather-search.033e079c.svg";